import React from 'react';
import { Headline } from '../components/headline/Headline';
import { Link } from "react-router-dom";
import Card from '../components/card/Card';
import Slider from '../components/slider/Slider';

function About() {
  return (
    <main>
      <div className="border-bottom">
        <Headline level="h2">Über mich</Headline>
      </div>
      <div className="scrollable cardgrid">

        <Card height="100" width="5">
          <Slider />
          <Headline level="h3">Moini, ich bin Marbin. Senior Full Stack Developer bei der GROW Agency GmbH in Hamburg.</Headline>
          <p>
            Ich habe ein crkbd v3 und eine Olympia SM3.
            Ein MacBook und ein ThinkPad T480 (Arch btw).
            Eine Forerunner 165 und eine automatische Seiko.
          </p>
          <p>
            Ist schon angekommen, dass ich Technik liebe?
          </p>
          <p>
            Mich begeistert, was technisch gerade alles möglich ist.
            Genauso schätze ich Lösungen, die durch Zeit, Design und Handwerk überzeugen.
          </p>
          <p>
            Gute Software entsteht für mich genau aus dieser Kombination.
          </p>
          <p>
            (Viel spaß beim Googlen der Begriffe)</p>
        </Card>

        <Card width="7">
          <Headline level="h3">Berufserfahrung</Headline>
          <p>2018 - AKTUELL <br />↳ Senior Full Stack Developer bei <Link to="https://grow-agency.de/" target='external'>GROW Agency GmbH</Link></p>
          <p>2017 - 2018 <br />↳ Junior Mediengestalter bei COPYFUCHS</p>
        </Card>

        <Card width="7">
          <Headline level="h3">Bildung</Headline>
          <p>2026<br />↳ Ausbildung zum Ausbilder</p>
          <p>2014 - 2017 <br />↳ Ausbildung zum Mediengestalter bei COPYFUCHS</p>
        </Card>

        <Card width="4">
          <Headline level="h3">Fähigkeiten</Headline>
          <ul>
            <li>HTML, CSS/SASS, PHP, JavaScript, React, Node</li>
            <li>UI & UX Design</li>
            <li>Responsive Design</li>
            <li>Google Analytics & Tag Manager</li>
            <li>Content Management</li>
            <li>Projektmanagement</li>
            <li>Kundenkommunikation</li>
            <li>Social Media (TikTok, Instagram)</li>
            <li>Video Editing</li>
            <li>Sound Design</li>
            <li>Photography</li>
            <li>SEO</li>
          </ul>
        </Card>

        <Card width="3">
          <Headline level="h3">Tools</Headline>
          <ul>
            <li>Adobe Creative Cloud</li>
            <li>Docker</li>
            <li>WordPress</li>
            <li>Electron</li>
            <li>Figma / XD</li>
            <li>Office Suite</li>
            <li>daVinci Resolve</li>
            <li>FL Studio</li>
            <li>Jira</li>
          </ul>
        </Card>

        <Card width="7">
          <Headline level="h3">Kontakt</Headline>
          <p>
            ↳ <Link to="mailto:hallo@marb.in">hallo@marb.in</Link><br />
            ↳ <Link to="https://www.linkedin.com/in/marbin-karaus-4712112b0/" target='external'>LinkedIn</Link><br />
            ↳ <Link to="https://instagram.com/hallomarbin" target='external'>@hallomarbin</Link>
          </p>
        </Card>

        <Card width="7">
          <Headline level="h3">On repeat</Headline>
          <iframe title="Spotify Playlist" src="https://open.spotify.com/embed/playlist/37i9dQZF1EpkCViuFCJflw?utm_source=marbin&theme=0" width="100%" height="152" frameBorder="0" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
        </Card>

        <Card width="7">
          <Headline level="h3">Meine media rotation</Headline>
          <p>
            MUSIK<br />
            ↳ IGOR von Tyler, The Creator<br />
            ↳ Blonde von Frank Ocean<br />
            ↳ USB von Fred again...<br />
          </p>

          <p>
            TV<br />
            ↳ One Piece<br />
            ↳ New Girl<br />
            ↳ Jujutsu Kaisen<br />
          </p>
        </Card>

      </div>
    </main>
  );
}

export default About;